import React, {useContext} from 'react';

type PortalContextProps =
  | {
      portalType: 'internal';
    }
  | {
      portalType: 'client';
      clientName?: string;
      clientId: string;
    };

export const PortalContext = React.createContext<PortalContextProps | null>(null);

export function PortalProvider({
  children,
  ...props
}: {
  children: React.ReactNode;
} & PortalContextProps) {
  return <PortalContext.Provider value={{...props}}>{children}</PortalContext.Provider>;
}
export function usePortal() {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error('usePortal must be used within a PortalProvider');
  }
  return context;
}
export function useIsInternal() {
  const context = usePortal();
  return context.portalType === 'internal';
}
export function useIsClient() {
  const context = usePortal();
  return context.portalType === 'client';
}
